module.exports = __webpack_public_path__ + "static/media/TP_CC (Narra).50484f9f.png";